import { httpV2 } from "@/api/index";

/**
 * Solicita o resultado do modo de falha de rodopio de óleo.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetDiagnostics = function(resultId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultId}/OilWhirl`);
};

export default { GetDiagnostics };